<template>
  <div class="modal" v-if="modalShow" @click.self="handleClickClose">
    <div class="modal-content">
      <progressive-img
          :src="imgurl"
          :placeholder="`${imgurl}?imageView2/0/w/38`"
        />
      <div v-if="showModalFooter" class="modal-footer">
        <div v-if="showCancelmBtn" class="footer-cancel" @click="handleCancelCallback"></div>
        <div class="footer-confirm" @click="handleConfirmCallback"></div>
      </div>
    </div>
    <div v-if="showClosebtn" class="close">
      <img @click="handleClickClose" src="../adsense/static/close.png"/>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      imgurl: '',
      showClosebtn: false,
      showModalFooter: false,
      showCancelmBtn: false,
      modalShow: false,
      cancelCallback: null,
      confirmCallback: null,
    }
  },
  methods: {
    handleClickClose() {
      this.modalShow = false
    },
    handleCancelCallback() {
      if (typeof this.cancelCallback === 'function') {
        this.cancelCallback()
      }
      this.handleClickClose()
    },
    handleConfirmCallback() {
      if (typeof this.confirmCallback === 'function') {
        this.confirmCallback()
      }
      this.handleClickClose()
    },
  },
}
</script>
<style lang="scss" scoped>
.modal {
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.modal-content {
  width: 580px;
  position: relative;
  img {
    width: 100%;
  }
}
.modal-footer {
  position: absolute;
  left: 0;
  bottom: 50px;
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: 100;
  div{
    width: 50%;
    height: 100px;
  }
}
.close {
  width: 54px;
  position: absolute;
  right: -20px;
  top: -74px;
}

</style>
